import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';

import { AuthService } from '../utility-services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class TokenGuard implements CanActivate {
  private authService = inject(AuthService);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    if (!this.authService.isAuthenticated) {
      return true;
    }

    const returnUrl = route.queryParamMap.get('returnUrl') ?? undefined;

    await this.authService.redirectAfterAuthentication(returnUrl);

    return false;
  }
}
